import { useToolbarButtons } from "contexts/toolbars/hooks";
import { DefaultIconButton } from "features/quickAccessMenu/procore/defaultIconButton";

import { EnhancedTooltip } from "./tooltips";

interface ButtonRendererProps {
    toolbarId: string;
}

/**
 * Component that renders all buttons for a specific toolbar in the correct order
 */
export function ButtonRenderer({ toolbarId }: ButtonRendererProps) {
    const buttons = useToolbarButtons(toolbarId);

    if (buttons.length === 0) {
        return null;
    }

    return (
        <>
            {buttons.map((buttonEntry) => {
                const { config, state } = buttonEntry;

                if (!state.visible) {
                    return null;
                }
                const ButtonComponent = config.component || DefaultIconButton;
                const buttonElement = (
                    // Wrapping in a div to allow the tooltip to work when the
                    // button is disabled.
                    <div key={config.id}>
                        <ButtonComponent
                            id={config.id}
                            onClick={config.onClick}
                            active={state.active}
                            disabled={state.disabled}
                            title={config.tooltip ? undefined : config.title}
                            ref={config.ref}
                            hasExpander={config.hasExpander}
                            expanderActive={state.expanderActive}
                            expanderPosition={config.expanderPosition}
                        >
                            {config.icon}
                        </ButtonComponent>
                    </div>
                );

                if (config.tooltip) {
                    return (
                        <EnhancedTooltip key={config.id} config={config.tooltip} active={state.active}>
                            {buttonElement}
                        </EnhancedTooltip>
                    );
                }

                return buttonElement;
            })}
        </>
    );
}
